import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { FullscreenLoading } from './FullscreenLoading';
import { useUserContext } from '../../contexts/UserContext';
import useFeatures from '../../hooks/useFeatures';

type Role =
  | 'customer'
  | 'installer'
  | 'superadmin'
  | 'installerActingAsCustomer';

interface AuthGuardProps {
  component: JSX.Element;
  requiredRole: Role | Role[];
  requiresFeature?: string;
}

export default function AuthGuard({ component, requiredRole, requiresFeature }: AuthGuardProps) {
  const navigate = useNavigate();
  const { loading, isLoggedIn, isInstaller, installerId, isSuperAdmin } =
    useUserContext();
  const { canUseFeature, isLoading: featuresLoading } = useFeatures();

  useEffect(() => {
    if (!loading && !featuresLoading) {
      let userRoles: string[] = [];
      isLoggedIn && userRoles.push('customer');
      isInstaller && userRoles.push('installer');
      isSuperAdmin && userRoles.push('superadmin');
      installerId && userRoles.push('installerActingAsCustomer');

      console.log('User roles:', userRoles);

      const normalisedRequiredRoles = Array.isArray(requiredRole)
        ? requiredRole
        : [requiredRole];

      const hasPermission = normalisedRequiredRoles.some((reqRole) =>
        userRoles.includes(reqRole)
      );

      if (requiresFeature && !canUseFeature(requiresFeature) && !isSuperAdmin) {
        navigate(-1);
      }

      if (!hasPermission) {
        navigate(-1);
      }
    }
  }, [
    loading,
    isLoggedIn,
    isInstaller,
    installerId,
    isSuperAdmin,
    featuresLoading,
    canUseFeature,
    navigate,
    requiredRole,
    requiresFeature,
  ]);

  if (loading || featuresLoading) {
    return <FullscreenLoading />;
  } else {
    return component;
  }
}
